import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  AlertController,
  IonNav,
  MenuController,
  PopoverController,
} from '@ionic/angular';
import { CaseService } from 'src/app/services/case.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu-option.page.html',
  styleUrls: ['./menu-option.page.scss'],
})
export class MenuOptionComponent implements OnInit {
  profileDetailsText: string = '';
  signOutText: string = '';

  constructor(
    private caseService: CaseService,
    private alertCtrl: AlertController,
    private popoverController: PopoverController,
    private ionNav: IonNav,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}
  @Input() goToPersonalDetail: (myNav) => void;

  async ngOnInit() {
    await this.loadTranslations();
  }

  async loadTranslations() {
    try {
      const translations = await this.translate.get(['MENU.PROFILE_DETAILS', 'MENU.SIGN_OUT']).toPromise();
      this.profileDetailsText = translations['MENU.PROFILE_DETAILS'];
      this.signOutText = translations['MENU.SIGN_OUT'];
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error loading translations:', error);
      this.profileDetailsText = this.translate.instant('MENU.PROFILE_DETAILS');
      this.signOutText = this.translate.instant('MENU.SIGN_OUT');
      this.cdr.detectChanges();
    }
  }

  async confirmLogout() {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('MENU.CONFIRM_LOGOUT_HEADER'),
      message: this.translate.instant('MENU.CONFIRM_LOGOUT_MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('COMMON.CANCEL'),
          role: 'cancel',
          handler: () => {},
        },
        {
          text: this.translate.instant('MENU.SIGN_OUT'),
          handler: () => {
            localStorage.removeItem('remote_token');
            localStorage.removeItem('is_login');
            localStorage.removeItem('isConsent');
            let from_viewmycase = parseInt(
              localStorage.getItem('from_viewmycase')
            );
            if (from_viewmycase) {
              window.location.href = '/viewmycase';
            } else {
              window.location.href = '/login?dynamic=1';
            }
          },
        },
      ],
    });
    await alert.present();
  }

  goToProfile() {
    this.goToPersonalDetail && this.goToPersonalDetail(this.caseService.ionNav);
    this.popoverController.dismiss();
  }
}
